/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElTable as __unplugin_components_7 } from 'element-plus/es';import 'element-plus/es/components/table/style/css';
import { ElButton as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElInputNumber as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/input-number/style/css';
import { ElTableColumn as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/table-column/style/css';
import { ElInput as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "flex justify-between"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { apiUsdkGetCurrencyList, apiUsdkbatchAddGoods } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  __name: 'addGameGoodsModal',
  props: {
    gameInfo: {
      type: Object
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const confirmLoading = ref(false);
    const dialogVisible = ref(false);
    const tableData = ref([]);
    const currencyOptions = ref([]);
    const currency = ref('RMB');
    const handleAddItem = () => {
      const lastRow = tableData.value.length > 0 && tableData.value[tableData.value.length - 1];
      if (lastRow && (!lastRow.goods || !lastRow.name || !lastRow.price || !lastRow.desc)) {
        ElMessage.warning('请填写完整商品信息');
        return;
      }
      tableData.value.push({
        goods: '',
        name: '',
        price: undefined,
        desc: ''
      });
    };
    const handleClose = () => {
      dialogVisible.value = false;
      tableData.value = [];
    };
    const handleDelItem = index => {
      tableData.value.splice(index, 1);
    };
    const getCurrencyList = async () => {
      const res = await apiUsdkGetCurrencyList();
      if (res.code === 0) {
        currencyOptions.value = res.data;
      }
    };
    const getCurrencyName = currency => {
      let c = currencyOptions.value.find(item => item.currency === currency);
      return c && c.desc || currency;
    };
    const handleConfirm = () => {
      let data = JSON.parse(JSON.stringify(tableData.value));
      if (data.length <= 0) {
        ElMessage.warning('请添加商品信息');
        return;
      }
      for (let i = 0; i < data.length; i += 1) {
        const current = data[i];
        if (!current.goods) {
          ElMessage.warning('商品ID必填');
          return;
        }
        if (!current.name) {
          ElMessage.warning('商品名称必填');
          return;
        }
        if (!current.price) {
          ElMessage.warning('商品金额必填');
          return;
        }
        if (current.price <= 0) {
          ElMessage.warning('商品金额必须大于0');
          return;
        }
        data[i].currency = currency.value;
      }
      ElMessageBox.confirm(`您正在保存商品，商品全局币种选择为【${getCurrencyName(currency.value)}】。请务必确保商品ID及币种均正确后再进行保存。`, '提示', {
        confirmButtonText: '保存商品',
        cancelButtonText: '返回检查',
        type: 'warning'
      }).then(() => {
        confirmLoading.value = true;
        apiUsdkbatchAddGoods({
          gid: props.gameInfo && props.gameInfo.Id,
          goodsList: JSON.stringify(data)
        }).then(res => {
          if (res.code === 0) {
            handleClose();
          }
        }).finally(() => {
          confirmLoading.value = false;
        });
      }).catch(() => {
        console.log('ss');
      });
    };
    const openModal = () => {
      dialogVisible.value = true;
      getCurrencyList();
    };
    __expose({
      openModal
    });
    return (_ctx, _cache) => {
      const _component_el_option = __unplugin_components_0;
      const _component_el_select = __unplugin_components_1;
      const _component_el_form_item = __unplugin_components_2;
      const _component_el_input = __unplugin_components_3;
      const _component_el_table_column = __unplugin_components_4;
      const _component_el_input_number = __unplugin_components_5;
      const _component_el_button = __unplugin_components_6;
      const _component_el_table = __unplugin_components_7;
      const _component_el_dialog = __unplugin_components_8;
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "添加商品",
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        width: "1000px",
        "before-close": handleClose,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: _unref(confirmLoading),
          onClick: handleConfirm
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form_item, {
          label: "币种选择"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(currency),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(currency) ? currency.value = $event : null),
            placeholder: "请选择"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currencyOptions), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.currency,
                label: item.desc,
                value: item.currency
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]), _createVNode(_component_el_table, {
          ref: "tableRef",
          data: _unref(tableData),
          style: {
            "width": "100%"
          },
          class: "marginT20"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            property: "goods",
            label: "游戏商品ID",
            width: "200"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.goods,
              "onUpdate:modelValue": $event => scope.row.goods = $event,
              maxlength: "300"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            property: "name",
            label: "商品名称",
            width: "200"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.name,
              "onUpdate:modelValue": $event => scope.row.name = $event,
              maxlength: "300"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            property: "desc",
            label: "商品描述",
            width: "200"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input, {
              modelValue: scope.row.desc,
              "onUpdate:modelValue": $event => scope.row.desc = $event
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            property: "price",
            label: "商品金额"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_input_number, {
              modelValue: scope.row.price,
              "onUpdate:modelValue": $event => scope.row.price = $event,
              min: 0
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "150"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_button, {
              size: "small",
              link: "",
              type: "danger",
              onClick: $event => handleDelItem(scope.$index)
            }, {
              default: _withCtx(() => [_createTextVNode("删除")]),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_button, {
          class: "mt-4 marginT10 width100",
          onClick: handleAddItem
        }, {
          default: _withCtx(() => [_createTextVNode("添加")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});